import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  size?: 'lg' | 'sm';
};

/**
 * Gold is the action color on this page: 8.9:1 against the navy ground.
 * Crimson is reserved for tension (pain crosses, price rise, the "without" column).
 */
export function CtaButton({
  children,
  href = '#pricing',
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-7 py-5 text-lg sm:text-xl rounded-2xl min-h-[64px]' : 'px-5 py-3 text-sm rounded-xl';
  return <a href={href} className={`inline-flex w-full items-center justify-center text-center gap-2 bg-gold hover:bg-gold-hover text-gold-ink font-bold tracking-wide shadow-card hover:shadow-lift transition-all duration-200 focus:outline-none focus-visible:ring-4 focus-visible:ring-white/60 ${sizing} ${className}`} data-id="element-69" data-mp="ll7aji3ocrkc">
      {children}
    </a>;
}